import { CodeActionType } from 'app/area/indicator-factors/item/types';
import { endpoints } from 'app/area/indicator-factors/item/endpoints';

export const shouldCreateCodetableItem = (codeId: number, actionType: CodeActionType) => {
  return actionType === CodeActionType.Duplicate || (!codeId && codeId !== 0);
};

export const codetableItemEndpoint = (actionType: CodeActionType, codetableId: number) => {
  if (!actionType || !(Object.values(CodeActionType).includes(actionType)) || !codetableId) {
    return undefined;
  }
  return endpoints.code(codetableId);
};
